import { columns } from './columns';
import { filters } from './filters';
import { query } from './query';

const assigneeConfig = {
    columns,
    filters,
    queryFilter: query,
};

export default assigneeConfig;
